import { asyncApi } from "@/services/apiService";

const _baseEndpoint = `${process.env.VUE_APP_BASE_API}/api/job`;

export default {
  getTripLogging: async (reservationId, onBeginCallback, onFinallyCallback) => {
    return asyncApi.get(
      `${_baseEndpoint}/trip/${reservationId}/log`,
      onBeginCallback,
      onFinallyCallback
    );
  },
  createTripLog: async (reservationId, onBeginCallback, onFinallyCallback) => {
    return asyncApi.post(
      `${_baseEndpoint}/trip/${reservationId}/log`,
      onBeginCallback,
      onFinallyCallback
    );
  },
  updateTripLog: async (
    reservationId,
    reservationHistoryId,
    onBeginCallback,
    onFinallyCallback
  ) => {
    return asyncApi.put(
      `${_baseEndpoint}/trip/${reservationId}/log/${reservationHistoryId}`,
      onBeginCallback,
      onFinallyCallback
    );
  },
  completeTrip: async (
    reservationId,
    payload,
    onBeginCallback,
    onFinallyCallback
  ) => {
    return asyncApi.post(
      `${_baseEndpoint}/trip/${reservationId}/complete`,
      payload,
      onBeginCallback,
      onFinallyCallback
    );
  },
  backToRunStatus: async (
    reservationId,
    onBeginCallback,
    onFinallyCallback
  ) => {
    return asyncApi.put(
      `${_baseEndpoint}/trip/${reservationId}/set-as-run`,
      onBeginCallback,
      onFinallyCallback
    );
  },
  uploadEvidencePaxNoShow: async (
    reservationId,
    payload,
    onBeginCallback,
    onFinallyCallback
  ) => {
    return asyncApi.post(
      `${_baseEndpoint}/trip/${reservationId}/pax-no-show/evidence`,
      payload,
      onBeginCallback,
      onFinallyCallback
    );
  },
  confirmPaxNoShow: async (
    reservationId,
    payload,
    onBeginCallback,
    onFinallyCallback
  ) => {
    return asyncApi.post(
      `${_baseEndpoint}/trip/${reservationId}/pax-no-show`,
      payload,
      onBeginCallback,
      onFinallyCallback
    );
  },
  getAttachment: async (
    reservationId,
    query,
    onBeginCallback,
    onFinallyCallback
  ) => {
    return asyncApi.get(
      `${_baseEndpoint}/trip/${reservationId}/attachment/link?path=${query}`,
      onBeginCallback,
      onFinallyCallback
    );
  }
};



// WEBPACK FOOTER //
// ./src/services/job/tripLogJob/tripLogJobService.js